<template>
  <header class="header">
    <div class="container">
      <div class="container__elem container__elem--12">
        <div class="header__inner">
          <div class="header__top">
            <div class="header__top-logo">
              <button @click="openPage('')">
                <img src="../assets/img/logo.png" alt="logo">
              </button>
            </div>
            <div class="header__top-menu">
              <div class="header__top-btn">
                <span>г. Самара</span>
                <i>
                  <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M0.979156 8.79803C0.979156 4.30726 4.55875 0.645844 8.99999 0.645844C13.4412 0.645844 17.0208 4.30726 17.0208 8.79803C17.0208 10.966 16.403 13.2939 15.3107 15.305C14.2198 17.3137 12.626 19.0591 10.6321 19.9911C9.59634 20.4752 8.40364 20.4752 7.36786 19.9911C5.374 19.0591 3.78014 17.3137 2.68925 15.305C1.59702 13.2939 0.979156 10.966 0.979156 8.79803ZM8.99999 2.02084C5.34105 2.02084 2.35416 5.04354 2.35416 8.79803C2.35416 10.7203 2.90657 12.8241 3.89755 14.6488C4.88988 16.476 6.29218 17.9705 7.95008 18.7454C8.61687 19.0571 9.38311 19.0571 10.0499 18.7454C11.7078 17.9705 13.1101 16.476 14.1024 14.6488C15.0934 12.8241 15.6458 10.7203 15.6458 8.79803C15.6458 5.04354 12.6589 2.02084 8.99999 2.02084ZM8.99999 6.60418C7.8609 6.60418 6.93749 7.52759 6.93749 8.66668C6.93749 9.80576 7.8609 10.7292 8.99999 10.7292C10.1391 10.7292 11.0625 9.80576 11.0625 8.66668C11.0625 7.52759 10.1391 6.60418 8.99999 6.60418ZM5.56249 8.66668C5.56249 6.7682 7.10151 5.22918 8.99999 5.22918C10.8985 5.22918 12.4375 6.7682 12.4375 8.66668C12.4375 10.5652 10.8985 12.1042 8.99999 12.1042C7.10151 12.1042 5.56249 10.5652 5.56249 8.66668Z"
                      fill="white" />
                  </svg>


                </i>
              </div>
              <div class="header__top-btn header__top-btn--lc" @click="handleButtonClick">
                <span>{{ isAuthorized ? userInitials : "&nbsp&nbsp Войти &nbsp&nbsp" }}</span>
              </div>
              <button v-if="isAuthorized" :class="{ active: burgerMenuBtnActive }" class="header__burger-close"
                @click="handleBurgerClick()">
                <span></span>
                <span></span>
                <span></span>
              </button>

            </div>
            <div ref="burgerMenu" v-if="showBurgerMenu && isAuthorized" :class="{ show: showBurgerMenuShow }"
              class="header__burger">
              <div class="header__burger-head">
                <p class="header__burger-name">{{ user.name }}</p>
                <button @click="closeBurgerMenu()">
                  <i>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L17 17M1 17L17 1" stroke="white" stroke-width="1.5" />
                    </svg>
                  </i>
                </button>
              </div>
              <button @click="navigateTo('/usersetting');" class="header__burger-btn">
                <i>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="9" r="3" stroke="white" stroke-width="1.5" />
                    <circle cx="12" cy="12" r="10" stroke="white" stroke-width="1.5" />
                    <path d="M17.9692 20C17.8101 17.1085 16.9248 15 12 15C7.07527 15 6.18997 17.1085 6.03082 20"
                      stroke="white" stroke-width="1.5" stroke-linecap="round" />
                  </svg>

                </i>
                <p>Настройка профиля</p>
              </button>
              <button @click="navigateTo('/playlistsetting');" class="header__burger-btn">
                <i>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="3" stroke="white" stroke-width="1.5" />
                    <path
                      d="M13.7654 2.15224C13.3978 2 12.9319 2 12 2C11.0681 2 10.6022 2 10.2346 2.15224C9.74457 2.35523 9.35522 2.74458 9.15223 3.23463C9.05957 3.45834 9.0233 3.7185 9.00911 4.09799C8.98826 4.65568 8.70226 5.17189 8.21894 5.45093C7.73564 5.72996 7.14559 5.71954 6.65219 5.45876C6.31645 5.2813 6.07301 5.18262 5.83294 5.15102C5.30704 5.08178 4.77518 5.22429 4.35436 5.5472C4.03874 5.78938 3.80577 6.1929 3.33983 6.99993C2.87389 7.80697 2.64092 8.21048 2.58899 8.60491C2.51976 9.1308 2.66227 9.66266 2.98518 10.0835C3.13256 10.2756 3.3397 10.437 3.66119 10.639C4.1338 10.936 4.43789 11.4419 4.43786 12C4.43783 12.5581 4.13375 13.0639 3.66118 13.3608C3.33965 13.5629 3.13248 13.7244 2.98508 13.9165C2.66217 14.3373 2.51966 14.8691 2.5889 15.395C2.64082 15.7894 2.87379 16.193 3.33973 17C3.80568 17.807 4.03865 18.2106 4.35426 18.4527C4.77508 18.7756 5.30694 18.9181 5.83284 18.8489C6.07289 18.8173 6.31632 18.7186 6.65204 18.5412C7.14547 18.2804 7.73556 18.27 8.2189 18.549C8.70224 18.8281 8.98826 19.3443 9.00911 19.9021C9.02331 20.2815 9.05957 20.5417 9.15223 20.7654C9.35522 21.2554 9.74457 21.6448 10.2346 21.8478C10.6022 22 11.0681 22 12 22C12.9319 22 13.3978 22 13.7654 21.8478C14.2554 21.6448 14.6448 21.2554 14.8477 20.7654C14.9404 20.5417 14.9767 20.2815 14.9909 19.902C15.0117 19.3443 15.2977 18.8281 15.781 18.549C16.2643 18.2699 16.8544 18.2804 17.3479 18.5412C17.6836 18.7186 17.927 18.8172 18.167 18.8488C18.6929 18.9181 19.2248 18.7756 19.6456 18.4527C19.9612 18.2105 20.1942 17.807 20.6601 16.9999C21.1261 16.1929 21.3591 15.7894 21.411 15.395C21.4802 14.8691 21.3377 14.3372 21.0148 13.9164C20.8674 13.7243 20.6602 13.5628 20.3387 13.3608C19.8662 13.0639 19.5621 12.558 19.5621 11.9999C19.5621 11.4418 19.8662 10.9361 20.3387 10.6392C20.6603 10.4371 20.8675 10.2757 21.0149 10.0835C21.3378 9.66273 21.4803 9.13087 21.4111 8.60497C21.3592 8.21055 21.1262 7.80703 20.6602 7C20.1943 6.19297 19.9613 5.78945 19.6457 5.54727C19.2249 5.22436 18.693 5.08185 18.1671 5.15109C17.9271 5.18269 17.6837 5.28136 17.3479 5.4588C16.8545 5.71959 16.2644 5.73002 15.7811 5.45096C15.2977 5.17191 15.0117 4.65566 14.9909 4.09794C14.9767 3.71848 14.9404 3.45833 14.8477 3.23463C14.6448 2.74458 14.2554 2.35523 13.7654 2.15224Z"
                      stroke="white" stroke-width="1.5" />
                  </svg>

                </i>
                <p>Настройка плейлиста</p>
              </button>
              <button @click="navigateTo('/favoriteevents');" class="header__burger-btn">
                <i>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.15316 5.40838C10.4198 3.13613 11.0531 2 12 2C12.9469 2 13.5802 3.13612 14.8468 5.40837L15.1745 5.99623C15.5345 6.64193 15.7144 6.96479 15.9951 7.17781C16.2757 7.39083 16.6251 7.4699 17.3241 7.62805L17.9605 7.77203C20.4201 8.32856 21.65 8.60682 21.9426 9.54773C22.2352 10.4886 21.3968 11.4691 19.7199 13.4299L19.2861 13.9372C18.8096 14.4944 18.5713 14.773 18.4641 15.1177C18.357 15.4624 18.393 15.8341 18.465 16.5776L18.5306 17.2544C18.7841 19.8706 18.9109 21.1787 18.1449 21.7602C17.3788 22.3417 16.2273 21.8115 13.9243 20.7512L13.3285 20.4768C12.6741 20.1755 12.3469 20.0248 12 20.0248C11.6531 20.0248 11.3259 20.1755 10.6715 20.4768L10.0757 20.7512C7.77268 21.8115 6.62118 22.3417 5.85515 21.7602C5.08912 21.1787 5.21588 19.8706 5.4694 17.2544L5.53498 16.5776C5.60703 15.8341 5.64305 15.4624 5.53586 15.1177C5.42868 14.773 5.19043 14.4944 4.71392 13.9372L4.2801 13.4299C2.60325 11.4691 1.76482 10.4886 2.05742 9.54773C2.35002 8.60682 3.57986 8.32856 6.03954 7.77203L6.67589 7.62805C7.37485 7.4699 7.72433 7.39083 8.00494 7.17781C8.28555 6.96479 8.46553 6.64194 8.82547 5.99623L9.15316 5.40838Z"
                      stroke="white" stroke-width="1.5" />
                  </svg>

                </i>
                <p>Избранные мероприятия</p>
              </button>
              <div @click="logOut()" class="header__burger-btn">
                <i>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8 16C8 18.8284 8 20.2426 8.87868 21.1213C9.75736 22 11.1716 22 14 22H15C17.8284 22 19.2426 22 20.1213 21.1213C21 20.2426 21 18.8284 21 16V8C21 5.17157 21 3.75736 20.1213 2.87868C19.2426 2 17.8284 2 15 2H14C11.1716 2 9.75736 2 8.87868 2.87868C8 3.75736 8 5.17157 8 8"
                      stroke="white" stroke-width="1.5" stroke-linecap="round" />
                    <path
                      d="M8 19.5C5.64298 19.5 4.46447 19.5 3.73223 18.7678C3 18.0355 3 16.857 3 14.5V9.5C3 7.14298 3 5.96447 3.73223 5.23223C4.46447 4.5 5.64298 4.5 8 4.5"
                      stroke="white" stroke-width="1.5" />
                    <path d="M6 12L15 12M15 12L12.5 14.5M15 12L12.5 9.5" stroke="white" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </i>
                <p>Выйти из аккаунта</p>
              </div>
            </div>
          </div>
          <div class="header__menu">
            <div class="header__menu-btns">
              <button class="header__menu-btn" :class="{ active: page === '' }" @click="openPage('')">
                <i>
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 1H19H6ZM6 7H19H6ZM6 13H19H6ZM1 1H1.01H1ZM1 7H1.01H1ZM1 13H1.01H1Z" fill="#000" />
                    <path d="M6 1H19M6 7H19M6 13H19M1 1H1.01M1 7H1.01M1 13H1.01" stroke="#000" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>


                </i>
              </button>
              <button class="header__menu-btn" :class="{ active: page === 'calendar' }" @click="openPage('calendar')">
                <i>
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z"
                      fill="#000" />
                    <path
                      d="M16 17C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15C15.4477 15 15 15.4477 15 16C15 16.5523 15.4477 17 16 17Z"
                      fill="#000" />
                    <path
                      d="M12 12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11C11.5523 11 12 11.4477 12 12Z"
                      fill="#000" />
                    <path
                      d="M12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16Z"
                      fill="#000" />
                    <path
                      d="M6 13C6.55229 13 7 12.5523 7 12C7 11.4477 6.55229 11 6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13Z"
                      fill="#000" />
                    <path
                      d="M6 17C6.55229 17 7 16.5523 7 16C7 15.4477 6.55229 15 6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17Z"
                      fill="#000" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6 0.75C6.41421 0.75 6.75 1.08579 6.75 1.5V2.26272C7.412 2.24999 8.14133 2.24999 8.94346 2.25H13.0564C13.8586 2.24999 14.588 2.24999 15.25 2.26272V1.5C15.25 1.08579 15.5858 0.75 16 0.75C16.4142 0.75 16.75 1.08579 16.75 1.5V2.32709C17.0099 2.34691 17.2561 2.37182 17.489 2.40313C18.6614 2.56076 19.6104 2.89288 20.3588 3.64124C21.1071 4.38961 21.4392 5.33855 21.5969 6.51098C21.75 7.65018 21.75 9.1058 21.75 10.9435V13.0564C21.75 14.8941 21.75 16.3498 21.5969 17.489C21.4392 18.6614 21.1071 19.6104 20.3588 20.3588C19.6104 21.1071 18.6614 21.4392 17.489 21.5969C16.3498 21.75 14.8942 21.75 13.0565 21.75H8.94359C7.10585 21.75 5.65018 21.75 4.51098 21.5969C3.33856 21.4392 2.38961 21.1071 1.64124 20.3588C0.89288 19.6104 0.560763 18.6614 0.403135 17.489C0.249972 16.3498 0.249985 14.8942 0.25 13.0564V10.9436C0.249985 9.10582 0.249972 7.65019 0.403135 6.51098C0.560763 5.33855 0.89288 4.38961 1.64124 3.64124C2.38961 2.89288 3.33856 2.56076 4.51098 2.40313C4.7439 2.37182 4.99006 2.34691 5.25 2.32709V1.5C5.25 1.08579 5.58579 0.75 6 0.75ZM4.71085 3.88976C3.70476 4.02502 3.12511 4.27869 2.7019 4.7019C2.27869 5.12511 2.02502 5.70476 1.88976 6.71085C1.86685 6.88123 1.8477 7.06061 1.83168 7.25H20.1683C20.1523 7.06061 20.1331 6.88124 20.1102 6.71085C19.975 5.70476 19.7213 5.12511 19.2981 4.7019C18.8749 4.27869 18.2952 4.02502 17.2892 3.88976C16.2615 3.75159 14.9068 3.75 13 3.75H9C7.09318 3.75 5.73851 3.75159 4.71085 3.88976ZM1.75 11C1.75 10.146 1.75032 9.40273 1.76309 8.75H20.2369C20.2497 9.40273 20.25 10.146 20.25 11V13C20.25 14.9068 20.2484 16.2615 20.1102 17.2892C19.975 18.2952 19.7213 18.8749 19.2981 19.2981C18.8749 19.7213 18.2952 19.975 17.2892 20.1102C16.2615 20.2484 14.9068 20.25 13 20.25H9C7.09318 20.25 5.73851 20.2484 4.71085 20.1102C3.70476 19.975 3.12511 19.7213 2.7019 19.2981C2.27869 18.8749 2.02502 18.2952 1.88976 17.2892C1.75159 16.2615 1.75 14.9068 1.75 13V11Z"
                      fill="#000" />
                  </svg>


                </i>
              </button>
              <button class="header__menu-btn" :class="{ active: page === 'map' }" @click="openPage('map')">
                <i>
                  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.25 6.70031C3.25 3.10215 6.30876 0.25 10 0.25C13.608 0.25 16.6116 2.97488 16.7454 6.45788L17.2231 6.61714C17.6863 6.77148 18.0922 6.90676 18.4142 7.05657C18.7623 7.21853 19.0814 7.42714 19.3253 7.76554C19.5692 8.10394 19.6662 8.47259 19.7098 8.85407C19.7501 9.20695 19.75 9.63482 19.75 10.123V15.8712C19.75 16.4806 19.7501 17.0005 19.7028 17.4176C19.653 17.8563 19.5418 18.2875 19.2404 18.6553C19.0674 18.8665 18.8573 19.0445 18.6205 19.1805C18.2081 19.4173 17.7645 19.4561 17.3236 19.433C16.9044 19.4111 16.3915 19.3256 15.7904 19.2254L15.7488 19.2185C14.456 19.003 13.9351 18.9216 13.4274 18.9641C13.2417 18.9796 13.0571 19.0074 12.875 19.0471C12.3774 19.1558 11.8988 19.3891 10.716 19.9805C10.6749 20.0011 10.6342 20.0214 10.594 20.0415C9.21137 20.7331 8.35952 21.1592 7.44031 21.2923C7.16384 21.3323 6.88482 21.3522 6.60546 21.3516C5.67668 21.3499 4.77995 21.0508 3.32536 20.5657C3.28328 20.5517 3.24074 20.5375 3.19772 20.5231L2.81415 20.3953L2.77684 20.3828C2.31373 20.2285 1.90783 20.0932 1.5858 19.9434C1.23766 19.7815 0.918614 19.5729 0.674708 19.2345C0.430803 18.8961 0.333789 18.5274 0.290236 18.1459C0.249948 17.793 0.249973 17.3652 0.250002 16.877L0.250002 11.8572C0.249971 11.0711 0.249945 10.4085 0.317291 9.88948C0.387586 9.34776 0.546523 8.81811 0.982624 8.4198C1.11082 8.30271 1.25213 8.20085 1.40375 8.11626C1.91953 7.8285 2.47226 7.84521 3.00841 7.94983C3.11717 7.97105 3.23109 7.99718 3.35019 8.02754C3.28411 7.5817 3.25 7.13723 3.25 6.70031ZM3.74869 9.70929C3.32072 9.57126 2.99224 9.47496 2.72113 9.42206C2.32599 9.34496 2.19646 9.39166 2.13459 9.42618C2.08405 9.45438 2.03694 9.48833 1.99421 9.52736C1.9419 9.57514 1.85663 9.68325 1.80482 10.0825C1.75151 10.4933 1.75 11.0575 1.75 11.908V16.8377C1.75 17.3768 1.75114 17.7181 1.78055 17.9758C1.80779 18.2143 1.85234 18.303 1.89157 18.3574C1.9308 18.4118 2.00083 18.4821 2.21849 18.5834C2.45364 18.6928 2.77709 18.8018 3.28849 18.9723L3.67205 19.1001C5.29563 19.6413 5.95089 19.8504 6.6083 19.8516C6.81478 19.852 7.02101 19.8374 7.22537 19.8078C7.87582 19.7136 8.50094 19.411 10.0452 18.6389C10.0765 18.6232 10.1074 18.6078 10.138 18.5925C11.1987 18.062 11.852 17.7352 12.555 17.5817C12.8014 17.5279 13.051 17.4903 13.3023 17.4693C14.0193 17.4093 14.7344 17.5286 15.8945 17.7221C15.9278 17.7276 15.9614 17.7332 15.9954 17.7389C16.6497 17.8479 17.0779 17.9181 17.4019 17.9351C17.7138 17.9514 17.821 17.9098 17.8735 17.8797C17.9524 17.8344 18.0225 17.775 18.0801 17.7046C18.1185 17.6578 18.1771 17.5589 18.2123 17.2486C18.2489 16.9262 18.25 16.4923 18.25 15.829V10.1623C18.25 9.62321 18.2489 9.28189 18.2195 9.02422C18.1922 8.7857 18.1477 8.69703 18.1084 8.64261C18.0692 8.58818 17.9992 8.51787 17.7815 8.41661C17.5464 8.30722 17.2229 8.19821 16.7115 8.02774L16.6527 8.00813C16.4625 9.30952 15.9996 10.6233 15.3173 11.7959C14.4048 13.364 13.0697 14.7299 11.3971 15.4595C10.5094 15.8468 9.49064 15.8468 8.60291 15.4595C6.93027 14.7299 5.59519 13.364 4.68273 11.7959C4.29871 11.136 3.9842 10.4313 3.74869 9.70929ZM10 1.75C7.06383 1.75 4.75 4.00208 4.75 6.70031C4.75 8.11775 5.18744 9.68084 5.97922 11.0415C6.77121 12.4026 7.88753 13.5109 9.20269 14.0847C9.70798 14.3051 10.292 14.3051 10.7973 14.0847C12.1125 13.5109 13.2288 12.4026 14.0208 11.0415C14.8126 9.68084 15.25 8.11775 15.25 6.70031C15.25 4.00208 12.9362 1.75 10 1.75ZM10 5.75C9.30965 5.75 8.75 6.30964 8.75 7C8.75 7.69036 9.30965 8.25 10 8.25C10.6904 8.25 11.25 7.69036 11.25 7C11.25 6.30964 10.6904 5.75 10 5.75ZM7.25 7C7.25 5.48122 8.48122 4.25 10 4.25C11.5188 4.25 12.75 5.48122 12.75 7C12.75 8.51878 11.5188 9.75 10 9.75C8.48122 9.75 7.25 8.51878 7.25 7Z"
                      fill="#000" />
                  </svg>


                </i>
              </button>
              <button @click="selectCustomFilter()" v-if="page == '' || page == 'calendar' || page == 'map'"
                class="header__menu-btn header__menu-btn--filter">Свой
                фильтр</button>
            </div>
            <div v-if="(page === '' || page === 'map') && weekItems.length === 7" class="header__week">
              <button class="header__week-btn" :class="{ disabled: isTodayInCurrentWeek }" @click="goToPreviousWeek"
                :disabled="isTodayInCurrentWeek">
                <i>
                  <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.608085 9.47085L11.6589 0.285566C12.3484 -0.28758 13.6667 0.0598392 13.6667 0.814718L13.6667 19.1853C13.6667 19.9402 12.3484 20.2876 11.6589 19.7144L0.608085 10.5292C0.241748 10.2247 0.241749 9.77534 0.608085 9.47085Z"
                      fill="#27AE60" />
                  </svg>
                </i>
              </button>
              <div class="header__week-items">
                <div v-for="weekItem in weekItems" :key="weekItem.id" class="header__week-item"
                  :class="{ active: isSelectedDate(weekItem.date), 'past-date': isPastDate(weekItem.date) }"
                  @click="!isPastDate(weekItem.date) && selectDate(weekItem.date)">
                  <div class="header__week-box">
                    <p class="header__week-name">{{ getWeekName(weekItem.date) }}</p>
                    <span class="header__week-num" v-if="eventsByWeek[weekItem.id - 1]">
                      {{ eventsByWeek[weekItem.id - 1] }}
                    </span>
                  </div>
                  <p class="header__week-date">{{ transformDateForMenu(weekItem.date) }}</p>
                </div>
              </div>
              <button class="header__week-btn" @click="goToNextWeek">
                <i>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16.3919 9.47085L5.34113 0.285567C4.65157 -0.28758 3.33334 0.0598392 3.33334 0.814719L3.33334 19.1853C3.33334 19.9402 4.65157 20.2876 5.34112 19.7144L16.3919 10.5292C16.7583 10.2247 16.7583 9.77534 16.3919 9.47085Z"
                      fill="#27AE60" />
                  </svg>
                </i>
              </button>
            </div>
            <p v-else class="header__namePage">{{ namePage }}</p>
          </div>
          <transition>
            <div :class="{ show: sectionsModal, showFirst: sectionsModalShow }" class="header__sections-overlay">
              <div class="header__sections-wrap">
                <button @click="sectionsModalCancel()" class="header__menu-section">
                  <i>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L13 13M1 13L13 1" stroke="#333333" stroke-width="1.5" />
                    </svg>
                  </i>
                </button>
                <p class="header__sections-descr">
                  Выберите категории
                </p>
                <div class="header__sections">
                  <div class="header__sections-content">
                    <div class="header__sections-list">
                      <div class="header__sections-inner header__sections-inner--allCategories"
                        @click="toggleAllCategories()">
                        <div class="header__sections-select--allCategories all">.</div>
                        <p class="header__sections-item--allCategories">
                          Выбрать все
                        </p>
                      </div>
                      <div class="header__sections-inner" v-for="category in categories" :key="category.id"
                        :class="{ active: selectedCategory === category }" @click="selectCategory(category)">
                        <div class="header__sections-select all" @click="toggleSelection">.</div>
                        <p class="header__sections-item" :class="{ active: ifMobile }" @click="openSubcategory()">
                          {{ category.name }} <span v-if="category.subcategoryCount > 0">{{ category.subcategoryCount
                            }}</span>
                        </p>
                      </div>
                    </div>
                    <div class="header__sections-choices">
                      <div class="header__sections-back" @click="closeSubcategory()">
                        <i>
                          <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.33337 1L1.33337 5L5.33337 9" stroke="#4BB85A" stroke-linecap="square" />
                          </svg>

                        </i>
                        <p>
                          Вернуться к категориям
                        </p>
                      </div>
                      <div class="header__sections-choice" :class="{ active: selectedCategory }">
                        <p class="header__sections-title">{{ selectedCategory ? selectedCategory.title : '' }}</p>
                        <div class="header__sections-inputs">
                          <div v-for="subcategory in selectedCategory ? selectedCategory.categories : []"
                            :key="subcategory.id"
                            :class="['header__sections-checkbox', { checked: selectedSubcategories[selectedCategory.id]?.includes(subcategory.id) }]">
                            <input type="checkbox" :id="`checkbox${subcategory.id}`" @click="clickOnSubcategories()"
                              :value="subcategory.id" v-model="selectedSubcategories[selectedCategory.id]" />
                            <label :for="`checkbox${subcategory.id}`">
                              {{ subcategory.name }} <span v-if="subcategory.eventCount > 0">{{ subcategory.eventCount
                                }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button @click="sectionsModalConfirm()" class="header__sections-btn">Применить</button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </header>
  <div v-if="showPopup" class="popup popup-date" id="datePopup">
    <div class="popup-date__inner">
      <h4 class="popup-date__title">Выбрать период</h4>
      <div class="popup-date__item">
        <p class="popup-date__text">с</p>
        <input class="popup-date__input" type="date" v-model="startDate" :min="today">
        <input class="popup-date__input" type="time" v-model="startTime">
      </div>
      <div class="popup-date__item">
        <p class="popup-date__text">до</p>
        <input class="popup-date__input" type="date" v-model="endDate" :min="today">
        <input class="popup-date__input" type="time" v-model="endTime">
      </div>
      <p class="popup-date__msg">дата конца периода не может быть меньше даты начала</p>
      <div class="popup-date__btns">
        <button class="popup-date__btn" @click="cancelDate">Отмена</button>
        <button class="popup-date__btn" @click="applyDate">Применить</button>
      </div>
    </div>
  </div>
  <transition>
    <LoginModal v-if="showLoginModal" :isVisible="showLoginModal" @close="showLoginModal = false" @refresh-events="refreshEvents"/>
  </transition>
</template>

<script>

import axios from 'axios';
axios.defaults.headers.common['X-API-KEY'] = 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1';
import LoginModal from './LoginModal.vue';

export default {
  name: 'Headers',
  components: {
    LoginModal,
  },
  data() {
    return {
      categories: [],
      selectedCategory: null,
      selectedSubcategories: {},
      oldSelectedSubcategories: {},
      allSelectedSubcategories: {},
      sectionsSelectStates: {},
      filteredEvents: [], // Список мероприятий после применения фильтров
      events: [], // Инициализируйте массив events
      dateItems: ['Сегодня', 'Завтра', 'На неделю', 'Выбранный период'],
      selectedDateText: this.getCurrentLocalDate(),
      oldSelectedDateText: this.getCurrentLocalDate(),
      oldSelectedDateTextForCalendar: 'На месяц',
      dateItemsForCalendar: ['На неделю', 'На месяц'],
      showPopup: false,
      today: new Date().toISOString().split('T')[0], // Текущая дата в формате YYYY-MM-DD
      currentTime: new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
      startDate: '',
      startTime: '00:00',
      endDate: '',
      endTime: '23:59',
      prevStartDate: null,
      prevStartTime: null,
      prevEndDate: null,
      prevEndTime: null,
      page: null,
      dateContainerView: true,
      loading: true,
      cancelTokenSource: null,
      cancelTokenSourceWeek: null,

      currentWeekStart: new Date(),
      weekItems: [
        { id: 1, date: new Date("2024-12-02T00:00:00+05:00") },
        { id: 2, date: new Date("2024-12-03T00:00:00+05:00") },
        { id: 3, date: new Date("2024-12-04T00:00:00+05:00") },
        { id: 4, date: new Date("2024-12-05T00:00:00+05:00") },
        { id: 5, date: new Date("2024-12-06T00:00:00+05:00") },
        { id: 6, date: new Date("2024-12-07T00:00:00+05:00") },
        { id: 7, date: new Date("2024-12-08T00:00:00+05:00") },
      ],
      eventsByWeek: [],
      menuVisible: false,

      isAuthorized: true, // Переменная авторизованности
      user: {
        name: "Иван",
        surname: "Петров",
        email: "example@gmail.com"
      },
      initials: '',
      showLoginModal: false,
      showBurgerMenu: false,
      showBurgerMenuShow: false,
      sectionsModal: false,
      sectionsModalShow: false,
      namePage: '',
      errorText: null,
      burgerMenuBtnActive: false,
      isBurgerLocked: false, // Блокировка кнопки
      isBurgerCloseLocked: false, // Блокировка кнопки
    };
  },
  computed: {
    selectedCategoryChoices() {
      if (this.selectedCategory) {
        return this.selectedCategory.categories || [];
      }
      return [];
    },
    isTodayInCurrentWeek() {
      const today = new Date();
      return this.weekItems.some(weekItem => {
        const weekDate = new Date(weekItem.date);
        // Сравниваем только дату, игнорируя время
        return (
          weekDate.getFullYear() === today.getFullYear() &&
          weekDate.getMonth() === today.getMonth() &&
          weekDate.getDate() === today.getDate()
        );
      });
    },
    userInitials() {
      if (this.user.name && this.user.surname) {
        // Если есть name и surname, возвращаем первые их буквы
        return `${this.user.name[0]}${this.user.surname[0]}`;
      } else if (this.user.name) {
        // Если есть только name
        return this.user.name.length > 1
          ? this.user.name.slice(0, 2) // Возвращаем первые две буквы, если имя длинное
          : this.user.name[0]; // Возвращаем одну букву, если имя короткое
      }
      return ""; // Если нет ни name, ни surname, возвращаем пустую строку
    }
  },
  emits: ['filtered-events', 'loading-state', 'categories-filter', 'sendErrorText', 'sendUserInfo'],
  methods: {
    refreshEvents(){
      this.combineAndEmitFilteredEvents();
      this.checkAuthorization()
      this.showLoginModal = false;
    },
    async combineAndEmitFilteredEvents() {

      if (this.page == '' || this.page == 'map') {
        this.$emit('loading-state', true, this.page); // Уведомляем о начале фильтрации      
        await this.loadWeekItems();
        this.events = null;
        const apiUrl = '/api/pis/v1/events/event';
        const devParam = window.innerWidth > 1023 ? 'd' : 'm';
        const viewParam = this.getViewParam();
        const { start, end } = this.getDateRange();

        const queryParams = new URLSearchParams({
          categories: Object.values(this.selectedSubcategories).flat(),
          start: start,
          end: end,
          dev: devParam,
          view: viewParam,
          sec_view: 'c'
        });

        // Отменяем предыдущий запрос, если он существует
        if (this.cancelTokenSource) {
          this.cancelTokenSource.cancel('Новый запрос отменяет предыдущий.');
        }

        // Создаем новый токен отмены
        this.cancelTokenSource = axios.CancelToken.source();
        try {
          const response = await axios.get(`${apiUrl}?${queryParams}`, {
            cancelToken: this.cancelTokenSource.token,
            headers: {
              'Content-Type': 'application/json',
            }
          });
          this.events = response.data;
        } catch (error) {
          if (axios.isCancel(error)) {
            // Если запрос был отменен, ничего не делаем
          } else {
            console.error('Ошибка при получении мероприятий:', error);
            this.$emit('sendErrorText', 'Ошибка при получении мероприятий: ' + error.message);
            this.$emit('loading-state', false, this.page); // Уведомляем о конце фильтрации

          }
        }

        this.$emit('filtered-events', this.events, this.selectedDateText, this.page);

        // Обновляем состояние после рендеринга
        this.$nextTick(() => {
          this.$emit('loading-state', false, this.page); // Уведомляем о конце фильтрации
        });
      } else {
        this.$emit('categories-filter', Object.values(this.selectedSubcategories).flat());
        this.$nextTick(() => {
          this.$emit('loading-state', false, this.page); // Уведомляем о конце фильтрации
        });
      }
    },

    getViewParam() {
      const currentPath = this.$route.path;
      if (currentPath === '/map') {
        return 'm';
      } else {
        return 'l';
      }
    },
    getDateRange() {
      // Функция форматирования даты
      const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      };


      const startDate = new Date(this.selectedDateText);
      const endDate = new Date(this.selectedDateText);

      // Устанавливаем начало и конец дня в локальной временной зоне
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      return {
        start: formatLocalDate(startDate),
        end: formatLocalDate(endDate)
      };
    },
    async fetchCategories() {
      try {
        const response = await fetch('/api/pis/v1/sections?sort=true', {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1'
          }
        });

        const data = await response.json();

        // Инициализация всех подкатегорий по умолчанию
        data.forEach(category => {
          this.selectedSubcategories[category.id] = category.categories.map(subcategory => subcategory.id);
          this.oldSelectedSubcategories[category.id] = category.categories.map(subcategory => subcategory.id);
          this.allSelectedSubcategories[category.id] = category.categories.map(subcategory => subcategory.id);
        });

        this.categories = data;
        await this.fetchEventCounts();
      } catch (error) {
        console.error('Ошибка при загрузке категорий:', error);
      }
    },
    toggleAllCategories() {
      let btn = document.querySelector('.header__sections-select--allCategories');

      if (btn.classList.contains('all')) {
        for (let category of this.categories) {
          this.selectedSubcategories[category.id] = [];
        }
        document.querySelectorAll('.header__sections-select').forEach(element => {
          element.classList.remove('all')
          element.classList.remove('some')
        });
      } else {
        this.categories.forEach(category => {
          this.selectedSubcategories[category.id] = category.categories.map(subcategory => subcategory.id);
        });
        document.querySelectorAll('.header__sections-select').forEach(element => {
          element.classList.add('all')
          element.classList.remove('some')
        });
      }
      this.refreshAllCategories()
    },
    refreshAllCategories() {
      let flag1 = 0;
      let flag2 = 1;  // Предположим, что все элементы не имеют ни класса 'all', ни класса 'some'

      let btn = document.querySelector('.header__sections-select--allCategories');

      document.querySelectorAll('.header__sections-select').forEach(element => {
        if (!element.classList.contains('all')) {
          flag1 = 1;
        }
        if (element.classList.contains('all') || element.classList.contains('some')) {
          flag2 = 0;  // Если хотя бы один элемент имеет класс 'all' или 'some', то flag2 будет 0
        }
      });

      if (flag1 == 0 && flag2 == 0) {
        btn.classList.add('all')
        btn.classList.remove('some')
      } else if (flag1 == 1 && flag2 == 0) {
        btn.classList.add('some')
        btn.classList.remove('all')
      } else if (flag1 == 1 && flag2 == 1) {
        btn.classList.remove('all')
        btn.classList.remove('some')
      }
    },
    selectCategory(category) {
      // Проверяем, есть ли уже сохраненные подкатегории для текущей категории
      if (!this.selectedSubcategories[category.id]) {
        // Если нет, инициализируем массив подкатегорий
        this.selectedSubcategories[category.id] = [];
      }

      this.selectedCategory = category;

    },
    resetAllSubcategories() {
      if (this.selectedCategory) {
        this.selectedSubcategories[this.selectedCategory.id] = [];
      }
    },
    clickOnSubcategories() {
      let currentElement = document.querySelector('.header__sections-inner.active');
      let selectElement = currentElement.querySelector('.header__sections-select');

      setTimeout(() => {
        if (this.selectedCategory && this.selectedCategory.categories.length > 0) {
          // Проверка, существует ли массив выбранных подкатегорий для текущей категории
          let selectedSubcategories = this.selectedSubcategories[this.selectedCategory.id] || [];

          // Проверка, если все подкатегории выбраны
          let allSubcategoriesSelected = this.selectedCategory.categories.every(subcategory =>
            Array.isArray(selectedSubcategories) && selectedSubcategories.includes(subcategory.id)
          );

          // Удаление всех классов, кроме .header__sections-select
          selectElement.className = 'header__sections-select';

          // Установка класса для header__sections-select в зависимости от результата проверки
          if (allSubcategoriesSelected) {
            selectElement.classList.add('all');
          } else if (selectedSubcategories.length > 0) {
            // Если есть выбранные подкатегории, но не все
            selectElement.classList.add('some');
          }
        } else {
          // Если нет выбранных подкатегорий, удаляем все классы, кроме .header__sections-select
          selectElement.className = 'header__sections-select';
        }

        this.refreshAllCategories();
      }, 10);
    },


    selectAllSubcategories() {
      if (this.selectedCategory) {
        this.selectedSubcategories[this.selectedCategory.id] = this.selectedCategory.categories.map(subcategory => subcategory.id);;
      }
    },
    applyCategoryFilters() {
      if (this.events != []) {

        this.events.filter(event => {
          return event.categories.some(category => this.selectedSubcategories[category.id]?.length > 0);
        });

        this.oldSelectedSubcategories = this.selectedSubcategories;



        this.combineAndEmitFilteredEvents(); // Передаем отфильтрованные события в метод
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    toggleDateList() {
      document.querySelector('.header__menu-date').classList.toggle('active');
    },
    async selectDate(date) {
      const selectedDate = new Date(date);
      const startOfDay = new Date(selectedDate);
      const endOfDay = new Date(selectedDate);

      // Устанавливаем начало дня (00:00:00) в локальной временной зоне
      startOfDay.setHours(0, 0, 0, 0);

      // Устанавливаем конец дня (23:59:59) в локальной временной зоне
      endOfDay.setHours(23, 59, 59, 999);

      // Форматирование дат в локальной временной зоне
      const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      };

      // Сохраняем в selectedDateText диапазон дат
      this.selectedDateText = formatLocalDate(startOfDay);


      // Вызываем метод для фильтрации событий
      this.combineAndEmitFilteredEvents();
      this.fetchEventCounts();
    },
    cancelDate() {
      this.toggleDateList();
      document.querySelector('html').classList.remove('animShowPopup');
      setTimeout(() => {
        this.showPopup = false;
        document.querySelector('html').classList.remove('showPopup');
      }, 500);
    },
    applyDate() {
      let popupInner = document.querySelector('.popup-date__inner');
      const isValidDate = (dateString, timeString) => {
        const combinedDateTime = `${dateString}T${timeString}`;
        const isValid = !isNaN(Date.parse(combinedDateTime));
        return isValid;
      };

      const formatTime = time => {
        const [hours, minutes] = time.split(':');
        return `${hours}:${minutes}`;
      };

      if (
        this.startDate &&
        this.endDate &&
        (
          (this.startDate < this.endDate) ||
          (this.startDate === this.endDate && this.startTime <= this.endTime)
        ) &&
        isValidDate(this.startDate, this.startTime) &&
        isValidDate(this.endDate, this.endTime)
      ) {
        const formattedStartTime = formatTime(this.startTime);
        const formattedEndTime = formatTime(this.endTime);

        let startDateObject = new Date(this.startDate);

        // Получаем день и месяц
        let startDay = ("0" + startDateObject.getDate()).slice(-2);
        let startMonth = ("0" + (startDateObject.getMonth() + 1)).slice(-2);

        let endDateObject = new Date(this.endDate);

        // Получаем день и месяц
        let endDay = ("0" + endDateObject.getDate()).slice(-2);
        let endMonth = ("0" + (endDateObject.getMonth() + 1)).slice(-2);

        this.selectedDateText = `${startDay}.${startMonth} ${formattedStartTime} - ${endDay}.${endMonth} ${formattedEndTime}`;
        this.setDateItem(this.selectedDateText);

        // Вызываем applyFilters после установки даты
        this.combineAndEmitFilteredEvents()
        popupInner.classList.remove('novalid');
        this.cancelDate();
        // Сохранение текущих значений при закрытии попапа
        this.prevStartDate = this.startDate;
        this.prevStartTime = this.startTime;
        this.prevEndDate = this.endDate;
        this.prevEndTime = this.endTime;

      } else {
        popupInner.classList.add('novalid');
      }
    },
    saveSectionsSelectStates() {
      const allSelectElements = document.querySelectorAll('.header__sections-select');

      allSelectElements.forEach(selectElement => {
        const categoryId = Array.from(document.querySelectorAll('.header__sections-select')).indexOf(selectElement) + 1;
        this.sectionsSelectStates[categoryId] = selectElement.className;
      });
    },
    restoreSectionsSelectStates() {
      const allSelectElements = document.querySelectorAll('.header__sections-select');

      allSelectElements.forEach(selectElement => {
        const categoryId = Array.from(document.querySelectorAll('.header__sections-select')).indexOf(selectElement) + 1;
        const savedState = this.sectionsSelectStates[categoryId];

        // Устанавливаем сохраненное состояние
        selectElement.className = savedState;
      });
    },
    resetSelectedCategories() {
      this.selectedSubcategories = JSON.parse(JSON.stringify(this.oldSelectedSubcategories));
      this.restoreSectionsSelectStates();
    },
    saveSelectedCategories() {
      this.oldSelectedSubcategories = JSON.parse(JSON.stringify(this.selectedSubcategories));
      this.saveSectionsSelectStates();
    },
    // checkChangeSubcategories() {
    //   let sectionCloseBtn = document.querySelector('.header__sections-btn');

    //   // Проверяем, что oldSelectedSubcategories и selectedSubcategories существуют
    //   if (!this.oldSelectedSubcategories || !this.selectedSubcategories) {
    //     // Если хотя бы одна из переменных отсутствует, предполагаем, что они пусты
    //     sectionCloseBtn.classList.add('disabled');
    //     return;
    //   }

    //   // Создаем копии объектов и сортируем их массивы
    //   const oldSortedSubcategories = Object.values(this.oldSelectedSubcategories).flat().sort();
    //   const newSortedSubcategories = Object.values(this.selectedSubcategories).flat().sort();

    //   // Сравниваем отсортированные массивы
    //   const isEqualSubcategories = isEqual(oldSortedSubcategories, newSortedSubcategories);

    //   if (isEqualSubcategories) {
    //     sectionCloseBtn.classList.add('disabled');
    //   } else {
    //     sectionCloseBtn.classList.remove('disabled');
    //   }
    // },
    async openPage(page) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.page = page;
      this.$emit('loading-state', true, page); // Уведомляем о начале фильтрации
      this.$router.push({ path: '/' + page });

      var menu = document.querySelector('.header__menu-section');
      if (menu && menu.classList.contains('active')) {
        document.querySelector('.header__sections').classList.remove('active');
        menu.classList.remove('active');
        document.querySelector('.header__menu').classList.remove('active');
        document.querySelector('.header__sections-btn').classList.add('disabled');
      }

      if (this.page == '' || this.page == 'map' || this.page == 'calendar') {
        await this.fetchCategories();
      }

      await this.combineAndEmitFilteredEvents();
    },
    getDateItems() {
      if (this.page === 'calendar') {
        return this.dateItemsForCalendar;
      } else {
        return this.dateItems;
      }
    },
    setDateItem(item) {
      if (this.page === 'calendar') {
        this.oldSelectedDateTextForCalendar = item;
      } else {
        this.oldSelectedDateText = item;
      }
    },
    getDateRangeForWeek() {
      const today = new Date();
      const firstDayOfWeek = today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1); // Первый день недели (понедельник)
      const lastDayOfWeek = firstDayOfWeek + 6; // Последний день недели (воскресенье)

      const start = new Date(today.setDate(firstDayOfWeek)).toISOString().split('T')[0]; // Дата начала недели
      const end = new Date(today.setDate(lastDayOfWeek)).toISOString().split('T')[0]; // Дата конца недели

      return { start, end };
    },
    getDateRangeForFetch() {
      const start = new Date(this.currentWeekStart);
      const end = new Date(this.currentWeekStart);

      // Устанавливаем начало недели на понедельник
      start.setHours(0, 0, 0, 0); // Начало дня

      // Устанавливаем конец недели на воскресенье
      end.setDate(end.getDate() + 6); // Воскресенье (т.е. 6 дней после понедельника)
      end.setHours(23, 59, 59, 999); // Конец дня

      // Форматируем даты для запроса
      const formattedStart = this.formatDateForApi(start);
      const formattedEnd = this.formatDateForApi(end);

      return { start: formattedStart, end: formattedEnd };
    },

    formatDateForApi(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
      const day = String(date.getDate()).padStart(2, '0'); // Дни с 0
      const hours = String(date.getHours()).padStart(2, '0'); // Часы
      const minutes = String(date.getMinutes()).padStart(2, '0'); // Минуты
      const seconds = String(date.getSeconds()).padStart(2, '0'); // Секунды

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    },

    async loadWeekItems() {

      const currentDate = new Date();
      const dayOfWeek = currentDate.getDay();
      const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Найти понедельник
      currentDate.setDate(currentDate.getDate() + diffToMonday);

      this.weekItems = []; // Очищаем массив перед заполнением
      for (let i = 0; i < 7; i++) {
        const date = new Date(this.currentWeekStart);
        date.setDate(this.currentWeekStart.getDate() + i);
        date.setHours(0, 0, 0, 0);
        this.weekItems.push({ id: i + 1, date: date });
      }

      await this.loadEventCountsByDays();
    },
    // Метод для переключения на предыдущую неделю
    async goToPreviousWeek() {
      if (!this.isTodayInCurrentWeek) {
        this.currentWeekStart.setDate(this.currentWeekStart.getDate() - 7);
        this.loadWeekItems(); // Обновляем weekItems

        // Находим первый доступный день начиная с понедельника
        for (let i = 0; i < 7; i++) {
          const weekItemDate = new Date(this.currentWeekStart);
          weekItemDate.setDate(this.currentWeekStart.getDate() + i); // Получаем дату каждого дня недели

          // Проверяем, доступен ли день
          if (!this.isPastDate(weekItemDate)) {
            this.selectDate(weekItemDate); // Выбираем доступный день
            break; // Прерываем цикл после выбора первого доступного дня
          }
        }
      }
    },

    // Метод для переключения на следующую неделю
    async goToNextWeek() {
      this.currentWeekStart.setDate(this.currentWeekStart.getDate() + 7);
      this.loadWeekItems(); // Обновляем weekItems

      // Находим первый доступный день начиная с понедельника
      for (let i = 0; i < 7; i++) {
        const weekItemDate = new Date(this.currentWeekStart);
        weekItemDate.setDate(this.currentWeekStart.getDate() + i); // Получаем дату каждого дня недели

        // Проверяем, доступен ли день
        if (!this.isPastDate(weekItemDate)) {
          this.selectDate(weekItemDate); // Выбираем доступный день
          break; // Прерываем цикл после выбора первого доступного дня
        }
      }
    },

    isSelectedDate(weekDate) {
      // Преобразуем `selectedDateText` и `weekDate` к формату "YYYY-MM-DD" в локальной зоне
      const selectedDate = new Date(this.selectedDateText)
        .toLocaleDateString('en-CA'); // Формат "YYYY-MM-DD"

      const weekDateFormatted = new Date(weekDate)
        .toLocaleDateString('en-CA'); // Формат "YYYY-MM-DD"

      return selectedDate === weekDateFormatted;
    },

    // Проверяем, прошла ли дата (вчера и ранее)
    isPastDate(weekDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Устанавливаем начало сегодняшнего дня
      const weekDateObj = new Date(weekDate);
      return weekDateObj < today; // Возвращаем true, если день прошел
    },
    getWeekName(date) {
      const daysOfWeek = {
        0: 'ВС',  // Воскресенье
        1: 'ПН',  // Понедельник
        2: 'ВТ',  // Вторник
        3: 'СР',  // Среда
        4: 'ЧТ',  // Четверг
        5: 'ПТ',  // Пятница
        6: 'СБ'   // Суббота
      };

      const dayIndex = new Date(date).getDay(); // Получаем индекс дня недели
      return daysOfWeek[dayIndex]; // Возвращаем соответствующее сокращение
    },
    transformDateForMenu(date) {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, '0'); // Получаем день с ведущим нулем, если нужно
      const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Получаем месяц (добавляем 1, так как getMonth() возвращает 0-11)

      return `${day}.${month}`; // Возвращаем строку в формате DD.MM
    },
    async loadEventCountsByDays() {
      // Получаем даты начала и конца недели
      const { start, end } = this.getDateRangeForFetch(); // Метод для получения начала и конца недели
      const apiUrl = '/api/pis/v1/events/event_counts_by_days';

      // Создаем объект для параметров
      const queryParams = new URLSearchParams({
        categories: Object.values(this.selectedSubcategories).flat(),
        start: start,
        end: end
      });

      // Отменяем предыдущий запрос, если существует
      if (this.cancelTokenSourceWeek) {
        this.cancelTokenSourceWeek.cancel('Новый запрос отменяет предыдущий.');
      }

      // Создаем новый токен отмены
      this.cancelTokenSourceWeek = axios.CancelToken.source();

      try {
        // Выполняем запрос
        const response = await axios.get(`${apiUrl}?${queryParams}`, {
          cancelToken: this.cancelTokenSourceWeek.token
        });

        this.eventsByWeek = response.data; // Предполагается, что это массив чисел


      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error('Ошибка при получении количества мероприятий:', error.response ? error.response.data : error.message);
        }
      }
    },
    initializeCurrentWeekStart() {
      const today = new Date();
      const dayOfWeek = today.getDay(); // Получаем день недели (0 - воскресенье, 1 - понедельник, ..., 6 - суббота)

      // Вычисляем разницу, чтобы получить понедельник текущей недели
      const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Если воскресенье, двигаемся на -6, иначе - (номер дня - 1)
      today.setDate(today.getDate() + diffToMonday); // Устанавливаем дату на понедельник текущей недели

      this.currentWeekStart = today; // Обновляем currentWeekStart
    },
    getCurrentLocalDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    },
    selectAllEvents() {
      this.selectedSubcategories = this.allSelectedSubcategories;
      this.combineAndEmitFilteredEvents();
      document.querySelectorAll('.events__menu-item').forEach(item => {
        item.classList.remove('active');
      });
      let filterBtn = document.querySelector('.header__menu-btn--filter');
      if (filterBtn) {
        filterBtn.classList.remove('active')
      }
      document.querySelector('.events__menu-item:nth-child(2)').classList.add('active')
    },
    selectCustomFilter() {
      this.selectedSubcategories = this.oldSelectedSubcategories;
      this.saveSelectedCategories();
      this.sectionsModal = true;
      setTimeout(() => {
        this.sectionsModalShow = true;
      }, 1);
      setTimeout(() => {
        const firstCategory = document.querySelector('.header__sections-item');
        const firstChoice = document.querySelector('.header__sections-choice');

        if (firstCategory && firstChoice) {
          // Присваиваем класс active выбранным элементам
          firstCategory.classList.add('active');
          firstChoice.classList.add('active');

          // Имитируем клик по первой категории
          this.selectCategory(this.categories[0]);
        }
      }, 10);
    },
    async selectAccount() {
      if (this.isAuthorized) {
        this.$emit('loading-state', true, this.page); // Уведомляем о начале фильтрации
        try {
          // Отправляем запрос на получение категорий
          const response = await axios.get('/api/pis/v1/playlists/user/categories', {
            headers: {
            'Content-Type': 'application/json',
            },
          });

          // Обновляем категории и выбираем их, если запрос успешен
          if (response.status === 200) {
            let tempSubcategories = {}

            this.categories.forEach(category => {
              // Отфильтровываем подкатегории по id, которые есть в response.data.categories
              const filteredSubcategories = category.categories.filter(subcategory =>
                response.data.categories.includes(subcategory.id)
              );

              // Заполняем selectedSubcategories для каждой категории
              tempSubcategories[category.id] = filteredSubcategories.map(subcategory => subcategory.id);
            });

            this.selectedSubcategories = tempSubcategories;

            // Обновляем отображение
            this.combineAndEmitFilteredEvents();

            // Обновляем классы для пунктов меню
            document.querySelectorAll('.events__menu-item').forEach(item => {
              item.classList.remove('active');
            });
            let filterBtn = document.querySelector('.header__menu-btn--filter');
            if (filterBtn) {
              filterBtn.classList.remove('active')
            }
            document.querySelector('.events__menu-item:nth-child(3)').classList.add('active');
          }
        } catch (error) {
          console.error('Ошибка при получении категорий:', error);
          this.$emit('sendErrorText', 'Ошибка при получении категорий: ' + error.message);
          this.$emit('loading-state', false, this.page); // Уведомляем о конце фильтрации
        }
      } else {
        this.showLoginModal = true;
      }
    },

    // Авторизация
    handleButtonClick() {
      if (!this.isBurgerLocked) {
        this.isBurgerCloseLocked = true; // Блокируем кнопку
        setTimeout(() => {
          this.isBurgerCloseLocked = false; // Блокируем кнопку
        }, 600);
        if (this.isAuthorized) {
          if (window.innerWidth >= 640) {
            if (this.showBurgerMenu) {
              this.closeBurgerMenu();
            } else {
              this.showBurgerMenu = true;
              setTimeout(() => {
                this.showBurgerMenuShow = true;
              }, 1);
            }
          }
        } else {
          this.showLoginModal = true; // Открытие модального окна для авторизации
        }
      }
    },
    closeBurgerMenu() {
      if (!this.isBurgerCloseLocked) {
        this.isBurgerLocked = true; // Блокируем кнопку
        this.showBurgerMenuShow = false;
        this.burgerMenuBtnActive = false;
        setTimeout(() => {
          this.showBurgerMenu = false;
        }, 300);
        setTimeout(() => {
          this.isBurgerLocked = false;
        }, 600);
      }
    },
    handleBurgerClick() {
      if (this.showBurgerMenu) {
        this.burgerMenuBtnActive = false;
      } else {
        this.showBurgerMenu = true;
        setTimeout(() => {
          this.showBurgerMenuShow = true;
          this.burgerMenuBtnActive = true;
        }, 1);
      }
    },
    async logOut() {
      if (!this.isBurgerCloseLocked) {
        try {
          // Отправляем запрос на удаление сессии
          await axios.post('/api/pis/v1/logout', null, {
            headers: {
              'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
              'Content-Type': 'application/json',
            },
          });

          // Удаляем данные пользователя из хранилища
          localStorage.removeItem('userInfo');
          sessionStorage.removeItem('userInfo');

          // Сбрасываем статус авторизации
          this.isAuthorized = false;

          // Закрываем бургер-меню
          this.showBurgerMenu = false;

          // Перенаправляем на главную страницу и обновляем страницу
          this.$router.push({ path: '/' });
          window.location.reload();
          this.openPage('');
        } catch (error) {
          // Удаляем данные пользователя из хранилища
          localStorage.removeItem('userInfo');
          sessionStorage.removeItem('userInfo');

          // Сбрасываем статус авторизации
          this.isAuthorized = false;

          // Закрываем бургер-меню
          this.showBurgerMenu = false;

          // Перенаправляем на главную страницу и обновляем страницу
          this.$router.push({ path: '/' });
          window.location.reload();
          this.openPage('');
        }
      }
    },

    async checkAuthorization() {
      try {
        // Выполняем запрос к user_info
        const response = await axios.get('/api/pis/v1/user/user_info', {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
          },
        },{ withCredentials: true });

        // Проверяем, если данные пользователя получены
        const userInfo = response.data;
        if (userInfo && userInfo.email) {
          this.isAuthorized = true; // Пользователь авторизован

          // Сохраняем данные в хранилище
          const storage = localStorage.getItem('userInfo') ? localStorage : sessionStorage;
          storage.setItem('userInfo', JSON.stringify(userInfo));

          // Обновляем локальное состояние
          this.user = userInfo;
          this.loading = false; // Завершаем процесс загрузки
        }
      } catch (error) {
        // Удаляем данные из хранилища
        localStorage.removeItem('userInfo');
        sessionStorage.removeItem('userInfo');

        // Сбрасываем статус авторизации
        this.isAuthorized = false;
        this.loading = false; // Завершаем процесс загрузки
      }
    },

    async fetchEventCounts() {
      // Получение диапазона дат
      const { start, end } = this.getDateRange();
      const queryParams = new URLSearchParams({ start, end });

      try {
        const response = await fetch(
          `/api/pis/v1/events/event_counts_for_categories?${queryParams}`,
          {
            headers: {
              'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
            },
          }
        );

        const countsData = await response.json();

        // Добавление count к категориям и подкатегориям
        countsData.sections.forEach((section) => {
          const category = this.categories.find((cat) => cat.id === section.id);
          if (category) {
            category.subcategoryCount = section.count; // Количество подкатегорий с мероприятиями
          }
        });

        countsData.categories.forEach((category) => {
          this.categories.forEach((cat) => {
            const subcat = cat.categories.find((sub) => sub.id === category.id);
            if (subcat) {
              subcat.eventCount = category.count; // Количество мероприятий в подкатегории
            }
          });
        });
      } catch (error) {
        console.error('Ошибка при получении количества мероприятий:', error);
      }
    },
    sectionsModalCancel() {
      this.resetSelectedCategories();
      this.saveSelectedCategories();
      this.sectionsModalShow = false;
      setTimeout(() => {
        this.sectionsModal = false;
      }, 500);
    },
    sectionsModalConfirm() {
      this.applyCategoryFilters();
      this.sectionsModalShow = false;
      setTimeout(() => {
        this.sectionsModal = false;
      }, 500);
      document.querySelectorAll('.events__menu-item').forEach(item => {
        item.classList.remove('active');
      });
      if (window.innerWidth < 1024) {
        document.querySelector('.header__menu-btn--filter').classList.add('active')
      } else {
        document.querySelector('.events__menu-item:nth-child(4)').classList.add('active')
      }
    },
    toggleSelection(event) {
      setTimeout(() => {
        let item = document.querySelector(".header__sections-inner.active > .header__sections-select")
        if (item.classList.contains('all')) {
          item.classList.remove('all');
          this.resetAllSubcategories();
          this.refreshAllCategories();
        } else if (item.classList.contains('some')) {
          item.classList.remove('some');
          item.classList.add('all');
          this.selectAllSubcategories();
          this.refreshAllCategories();
        } else {
          item.classList.add('all');
          this.selectAllSubcategories();
          this.refreshAllCategories();
        }
      }, 100);
    },
    ifMobile() {
      if (window.innerWidth < 639) {
        return true;
      } else {
        return false;
      }
    },
    openSubcategory() {
      document.querySelector('.header__sections-content').classList.add('active');
    },
    closeSubcategory() {
      document.querySelector('.header__sections-content').classList.remove('active');
    },
    navigateTo(path) {
      if (!this.isBurgerCloseLocked) {
        this.closeBurgerMenu();
        setTimeout(() => {
          if (this.$route.path === path) {
            this.$router.go(0);
          } else {
            this.$router.push(path);
          }
        }, 300);
      }
    },
    handleOutsideClick(event) {
      const menu = this.$refs.burgerMenu;
      if (menu && !menu.contains(event.target)) {
        this.closeBurgerMenu()
      }
    },
  },
  beforeDestroy() {
    // Убираем глобальный обработчик события
    document.removeEventListener("mousedown", this.handleOutsideClick);
  },
  mounted() {
    const storedUserInfo = localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo');
    if (storedUserInfo) {
      this.user = JSON.parse(storedUserInfo);
      this.isAuthorized = true;
    } else {
      this.isAuthorized = false;
    }

    const currentPath = this.$route.fullPath;
    if (currentPath === '/map') {
      this.openPage(currentPath.substring(1))

    } else if (currentPath === '/calendar') {
      this.openPage(currentPath.substring(1))

    } else if (currentPath === '/') {
      this.openPage(currentPath.substring(1))

    } else if (currentPath === '/usersetting') {
      this.namePage = "Настройка профиля";
      this.openPage(currentPath.substring(1))
      let btns = document.querySelectorAll('.header__menu-btn');
      btns.forEach(element => {
        element.classList.remove('active');
      });

    } else if (currentPath === '/playlistsetting') {
      this.namePage = "Настройка плейлиста Аккаунт";
      this.openPage(currentPath.substring(1))
      let btns = document.querySelectorAll('.header__menu-btn');
      btns.forEach(element => {
        element.classList.remove('active');
      });
    } else if (currentPath === '/favoriteevents') {
      this.namePage = "Избранные мероприятия";
      this.openPage(currentPath.substring(1))
      let btns = document.querySelectorAll('.header__menu-btn');
      btns.forEach(element => {
        element.classList.remove('active');
      });

    } else {
      this.page = '';
      this.dateContainerView = true;
      this.selectedDateText = this.oldSelectedDateText;
      let btns = document.querySelectorAll('.header__menu-btn');
      let btn = document.querySelector('.header__menu-btn:nth-child(1)');
      btns.forEach(element => {
        element.classList.remove('active');
      });
      btn.classList.add('active');
      this.openPage('')
    }
    this.checkAuthorization();
    this.initializeCurrentWeekStart();
    this.loadWeekItems();
    document.addEventListener("mousedown", this.handleOutsideClick);

  },

}
</script>
